import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer>
      <div>
        <a href="https://github.com/Ershad37" target="_blank" rel="noreferrer">
          <GitHubIcon />
        </a>
        <a href="https://www.linkedin.com/in/ahmad-mohammadi-a802a43a8/" target="_blank" rel="noreferrer">
          <LinkedInIcon />
        </a>
      </div>
      <p>© {new Date().getFullYear()} Ershad Mohammadi</p>
    </footer>
  );
}

export default Footer;